import type { FeaturePreferences } from "models/types/agency-settings";
import { apiClient } from "utils/api-client";
import { createModel } from "utils/models";

export const featurePreferencesModel = createModel("featurePreferences", {
  queries: {
    get: () => ({
      queryKey: ["featurePreferences"],
      queryFn: () => {
        return apiClient.get<FeaturePreferences>("accounts/preferences");
      },
    }),
  },
  mutations: {
    update: () => ({
      mutationKey: ["featurePreferences", "update"],
      mutationFn: async (data: FeaturePreferences) => {
        return apiClient.patch<FeaturePreferences>(
          "accounts/preferences",
          data,
        );
      },
    }),
  },
});
